








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FormatAddress extends Vue {
  @Prop({ required: true })
  public address: any;

  get formattedAddress(): Array<string> {
    const match = this.address.match(/^(.*),(.*[,].*),(.*)$/)
    if (match) {
        return [ match[1], match[2], match[3]];
    }
    return [this.address];
  }
}
